import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemSort = function IconSystemSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 4v16m0 0 4-4m-4 4-4-4m14 4V4m0 0 4 4m-4-4-4 4"
  }));
};